<template>
    <v-page-content>
        <div>
          <h3>
            <em class="far fa-lx fa-clock" v-if="type === statuses_.await"></em>
            <em class="far fa-1x fa-check-circle" v-if="type === statuses_.accepted"></em>
            <em class="far fa-1x fa-times-circle" v-if="type === statuses_.rejected"></em>
            <em class="fas fa-1x fa-ban" v-if="type === statuses_.removed"></em>
            <em class="fas fa-lx fa-tasks" v-if="type === statuses_.history"></em>
            {{title}}
          </h3>
          <content-types isCurator v-if="type === statuses_.history"
            @filter="getFilteredData" :disable="!loadedBefore"></content-types>
          <template v-if="(loadedBefore || page > 1) && content && content.length">
            <b-card v-for="item in content" :key="item.id.toString()"
                    no-body
                    border-variant="secondary"
                    class="overflow-hidden mb-3"
                    style="max-width: 100%;"
            >
                <div class="row">
                    <div class="col-md-4" style="display: flex; align-items: center;">
                        <b-link :to="getItemType(item) + '/' + item.id.toString()" append >
                            <b-card-img
                              :src="getAvatar(item)"
                              class="rounded-0 card-content-image" />
                        </b-link>
                    </div>
                    <div class="col-md-8">
                        <b-card-body :title="item.title">
                            <b-card-text>
                                <b-link :to="getItemType(item) + '/' + item.id.toString()" append
                                        style="float: right">
                                  <b-button variant="primary">
                                    Перейти к рассмотрению
                                  </b-button>
                                </b-link>
                                <p align="justify" style="word-wrap: break-word">
                                  Тип: {{ item.type }}
                                </p>
                                <p align="justify">
                                  Контент-менеджер: {{getContentManager(item)}}</p>
                                <p align="justify">
                                  Отправлено: {{ (new Date(getLastDateCreate(item))).toLocaleString() }}
                                </p>
                                <div
                                  v-if="type === statuses_.accepted ||
                                    type === statuses_.rejected ||
                                    type === statuses_.history"
                                >
                                    <p align="justify">
                                      Обработано: {{ getLastConfirmDate(item)
                                        ? (new Date(getLastConfirmDate(item))).toLocaleString()
                                        : '-'}}
                                    </p>
                                </div>
                                <div>
                                    <p align="justify">Последний комментарий:</p>
                                    <b-form-textarea no-resize disabled
                                            id="textarea"
                                            :value="getLastComment(item)"
                                            rows="3"
                                    ></b-form-textarea>
                                </div>
                            </b-card-text>
                        </b-card-body>
                    </div>
                </div>
            </b-card>
          </template>
          <b-alert v-else-if="loadedBefore"
            show variant="info" class="mx-auto">Контент отсутствует</b-alert>
          <template v-else>
            <skeleton-news :count="5"/>
          </template>
          <b-button
            variant="outline-primary"
            v-if="isMore"
            id='buttonShowMore'
            @click="showMore()"
          >
            Показать ещё контент
          </b-button>
        </div>
    </v-page-content>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import ContentTypes from '@/components/content/edit/ListGroupButtonContentTypes.vue'
import { statuses, statusFilters, statusTranslates } from '@/config/content/statuses'
import { typeTranslates } from '@/config/content/types'
import SkeletonNews from '@/components/ui/skeleton/SkeletonNews.vue'


export default {
  name: 'ContentList',
  components: {
    SkeletonNews,
    ContentTypes
  },
  props: {
    type: {
      type: String,
      default() {
        return statuses.accepted
      }
    }
  },
  data() {
    return {
      statuses_: statuses,
      defaultImage: '/images/w1400_1.jpg',
      filters: [{
        param: 'status',
        needle: [
          statusFilters.accepted,
          statusFilters.rejected,
          statusFilters.await,
          statusFilters.removed
        ]
      }],
      isMore: true,
      countOnPage: 10,
      sorting: null,
      page: 1,
      typeOfContent: null,
      loadedBefore: false
    }
  },
  beforeDestroy() {
    this.setAllPartners([])
    this.setEvents([])
    this.setNews([])
    this.setGPClasses([])
  },
  mounted() {
    this.getData()
  },
  beforeRouteLeave(to, from, next) {
    this.getData(to.path)
    next()
  },
  computed: {
    ...mapGetters({
      courses: 'content/getCourses',
      sims: 'content/getSims',
      partners: 'content/getAllPartners',
      events: 'content/getEvents',
      news: 'content/getNews',
      orgs: 'dicts/getOrganizations',
      classes: 'content/getGPClasses'
    }),
    content() {
      const concatList = this.partners
        .concat(this.events, this.news, this.classes, this.courses, this.sims)
        .sort(this.sortContentByUpdatedAt)
      return this.typeOfContent === statusFilters.await ? concatList.reverse() : concatList
    },
    title() {
      return statusTranslates[this.type]
    }
  },
  methods: {
    ...mapActions({
      fetchAllContent: 'content/fetchAllContent'
    }),
    ...mapMutations({
      setAllPartners: 'content/setAllPartners',
      setEvents: 'content/setEvents',
      setNews: 'content/setNews',
      setGPClasses: 'content/setGPClasses'
    }),
    checkPartnerType(item) {
      return item.type
    },
    getData(path = this.$route.path) {
      if (path === '/content/await') {
        this.getFilteredData(statusFilters.await)
      } else if (path === '/content/accepted') {
        this.getFilteredData(statusFilters.accepted)
      } else if (path === '/content/rejected') {
        this.getFilteredData(statusFilters.rejected)
      } else if (path === '/content/removed') {
        this.getFilteredData(statusFilters.removed)
      } else if (path.includes('/history_of_content')) {
        this.getFilteredData(statusFilters.history)
      }
    },
    getFilteredData(type) {
      this.loadedBefore = false
      this.typeOfContent = type
      if (type === statusFilters.history) {
        this.filters[0].needle = [
          statusFilters.accepted,
          statusFilters.rejected,
          statusFilters.await,
          statusFilters.removed
        ]
        this.sorting = [[
          'updatedAt', 'DESC'
        ]]
      } else {
        this.filters[0].needle = [type]
        if (type === statusFilters.await) {
          this.sorting = [[
            'updatedAt', 'ASC'
          ]]
        } else {
          this.sorting = [[
            'updatedAt', 'DESC'
          ]]
        }
      }
      this.page = 1
      this.fetchAllContent({
        perPage: this.countOnPage,
        pageNumber: this.page,
        filters: this.filters,
        sorting: this.sorting
      }).then(() => {
        this.loadedBefore = true
        this.isMore = this.content.length >= this.page * this.countOnPage
      })
    },
    sortContentByUpdatedAt(content1, content2) {
      return new Date(content2.updatedAt) - new Date(content1.updatedAt)
    },
    getAvatar(item) {
      if (item.avatar) {
        return `/api/files/${item.files.filter((p) => p.id === item.avatar)[0].physicalName}`
      }
      return this.defaultImage
    },
    getContentManager(item) {
      if (item.changeHistory && item.changeHistory.length) {
        const lastCM = _.findLast(item
          .changeHistory, (p) => p.status === statusFilters.await)
        if (lastCM && lastCM.user) {
          return `${lastCM.user.surname} ${lastCM.user.name[0]}. ${lastCM.user
            .midname ? (`${lastCM.user.midname[0]}.`) : ''}`
        }
      }
      return '-'
    },
    getLastDateCreate(item) {
      if (item.changeHistory && item.changeHistory.length) {
        const lastCMComment = _.findLast(item
          .changeHistory, (p) => statusFilters.await
          || p.status === statusFilters.removed)
        if (lastCMComment) {
          return lastCMComment.createdAt
        }
      }
      return item.createdAt
    },
    getLastConfirmDate(item) {
      if (item.changeHistory && item.changeHistory.length) {
        const lastCMComment = _.findLast(item
          .changeHistory, (p) => p.status === statusFilters.accepted
          || statusFilters.removed)
        if (lastCMComment) {
          return lastCMComment.createdAt
        }
      }
      return null
    },
    getLastComment(item) {
      if (item.changeHistory && item.changeHistory.length
        && item.changeHistory[item.changeHistory.length - 1].text) {
        return item.changeHistory[item.changeHistory.length - 1].text
      }
      return 'Комментарий не был оставлен'
    },
    showMore() {
      this.page += 1
      this.loadedBefore = false
      const oldSize = this.content.length
      this.fetchAllContent({
        perPage: this.countOnPage,
        pageNumber: this.page,
        filters: this.filters,
        sorting: this.sorting
      }).then(() => {
        this.loadedBefore = true
        if (this.content.length === oldSize
          || this.content.length < this.page * this.countOnPage) {
          this.isMore = false
        }
      })
    },
    getItemType(item) {
      return _.findKey(typeTranslates, (value) => item.type === value)
    }
  }
}
</script>

<style scoped>
    @media screen and (min-width: 768px){
        .card-content-image {
            margin-left: 20px;
        }
    }
    #buttonShowMore{
      width: 100%;
    }

</style>
